import Slider from "react-slick";

export default function PastDrawsCarousel(props) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    rows: 2,
    centerPadding: "60px",
    slidesPerRow: 1,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="past-draw-carousel">
      <div className="carousel-container">
        <Slider {...settings}>{props.children}</Slider>
      </div>
    </div>
  );
}
